/** @format */

import pathToRegexp from 'path-to-regexp';
import { useRouterStoreWithOut } from '@/store/modules/router';

/**
 * 获取正则表达式-通过配置的path返回对应的正则表达式用于检测某个字符串是否被匹配到
 * 		// const originstr = '/aaa/bbb/:id/:name';
 * 		// const pt = getPattenByOriginstr(originstr);
 * 		// pt.test('/aaa/bbb/123/ddd'); //true
 */
export function getPattenByOriginstr(originstr) {
	const regexp = pathToRegexp(originstr);
	return regexp;
}

export function matchedCommonPathComponent(path) {
	let Component = null;
	const routerStore = useRouterStoreWithOut();

	const { constantRouterComponents } = routerStore;
	const arr = Object.keys(constantRouterComponents);
	for (let i = 0; i < arr.length; i++) {
		const originstr = arr[i];
		const pt = getPattenByOriginstr(originstr);
		const matched = pt.test(path.split('?')[0]);
		if (matched) {
			// console.log('matched', matched);
			// console.log('path', path);
			// console.log('pt', pt);

			Component = constantRouterComponents[originstr];
			return { path: originstr, Component };
		}
	}
}
